// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  background: #ed143d;
  color: white;
  padding: 8px;
  font-size: 16px;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: start;
  justify-content: center;
  gap: 5px;
}
.error-container p {
  margin: 0;
}
.error-container ion-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.weekdays-container {
  display: flex;
  gap: 5px;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.weekdays-container ion-badge {
  background: none;
  color: #333;
  border: 1px solid #333;
  padding: 5px 6px;
}
.weekdays-container ion-badge.selected {
  background: #ed143d;
  color: white;
  border: 1px solid #ed143d;
}

.recurrence-end {
  display: flex;
  align-items: center;
}
.recurrence-end span {
  font-weight: 600;
  flex: 0.75;
  color: #888;
  margin: 0;
  font-size: 15px;
  padding: 0;
}
.recurrence-end ion-chip {
  display: flex;
  justify-content: space-between;
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  flex: 1;
}

.container {
  margin: 5px;
  border-radius: 8px;
  padding: 0 15px 50px 15px;
}
.container .time-container {
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: #efefef;
  padding: 5px 10px;
  border-radius: 8px;
  margin-block: 10px 20px;
  gap: 2px;
}
.container .time-container .meeting-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container .time-container .meeting-time .start-end-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.container .time-container .meeting-time .start-end-container div {
  display: flex;
  align-items: center;
}
.container .time-container .meeting-time .start-end-container div span {
  font-weight: 600;
  flex: 0.5;
  font-size: 15px;
  color: #888;
  margin: 0;
  padding: 0;
}
.container .time-container .meeting-time .start-end-container div ion-chip {
  display: flex;
  justify-content: center;
  border-radius: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.container .time-container .meeting-time .start-end-container div ion-chip.date-chip {
  margin-left: auto;
}
.container .time-container .meeting-time .start-end-container div ion-chip ion-icon {
  color: #ed143d;
}
.container .time-container .meeting-time .all-day {
  margin: 4px;
  margin-left: 0px;
}
.container .time-container .duration {
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;
}
.container .time-container .duration span {
  display: flex;
  font-size: 15px;
  align-items: center;
  font-weight: 600;
  color: #888;
  gap: 5px;
}
.container .time-container .duration span ion-icon {
  color: #ed143d;
  font-size: 18px;
}
.container .time-container .duration ion-chip {
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

ion-toggle {
  font-weight: 600;
  display: block;
  margin: 0 auto;
  --track-background-checked: #ed143d;
  width: 100%;
}

ion-datetime {
  --ion-color-primary: #ed143d;
  box-shadow: none;
  padding-top: 8px;
}

ion-datetime::part(calendar-day):focus {
  box-shadow: none;
}

ion-datetime::part(time-button) {
  background: #fff9f9;
  border: 2px solid #ed143d;
  font-weight: 600;
}

ion-datetime.disabled-time::part(time-button) {
  pointer-events: none;
  opacity: 0.3;
}

ion-datetime::part(month-year-button) {
  color: #ed143d;
  padding-block: 0;
  transform: translateY(-8px);
}

ion-popover.datetime-popover::part(content) {
  --width: 350px;
  --max-width: 90%;
  --height: auto;
}

ion-select::part(label) {
  color: #888;
  font-size: 17px;
}

ion-select::part(container) {
  font-size: 15px;
}

ion-select::part(icon) {
  color: #ed143d;
  transform: translateY(10px);
}

ion-select ion-icon {
  color: #ed143d;
  font-size: 20px;
  margin-right: 10px;
}

ion-popover.duration-popover {
  --offset-y: -200px;
}

.subject-input {
  font-weight: 600;
  padding: 10px 0 !important;
  margin: 10px;
  font-size: 21px;
}

ion-input::ng-deep .input-clear-icon {
  justify-content: end;
}

.disabled-page {
  pointer-events: none;
  opacity: 0.55;
}

.resource-and-edit-icon-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.resource-email-row {
  display: flex;
  align-items: center;
  padding: 4px 0 0 8px;
  font-size: 14px;
  color: #555;
}

.detail-row {
  display: flex;
  align-items: center;
  padding: 10px 0 4px 0;
  font-size: 16px;
}
.detail-row .detail-label {
  color: #888;
  font-weight: 600;
  margin-right: auto;
}
.detail-row .detail-value {
  color: #333;
  font-weight: 500;
  text-align: right;
}

.organizer-icon {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.resource-map-container {
  margin: 10px 0 20px 0;
  border-top: 1px solid #e0e0e0;
  padding-top: 15px;
}
.resource-map-container .map-container {
  width: 100%;
  height: 250px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.resource-map-container .map-container iframe {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  border: none;
}

.invitation-response-container {
  position: static;
  margin: 100px 0 20px 0;
  padding: 20px 16px;
  background: #fff;
}
@media (max-width: 576px) {
  .invitation-response-container {
    margin: 100px 0 15px 0;
    padding: 15px 12px;
  }
}
@media (max-width: 375px) {
  .invitation-response-container {
    margin: 80px 0 12px 0;
    padding: 12px 8px;
  }
}
.invitation-response-container .response-loading {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.invitation-response-container .response-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}
.invitation-response-container .response-actions .response-button {
  --border-radius: 8px;
  --padding-top: 14px;
  --padding-bottom: 14px;
  --padding-start: 24px;
  --padding-end: 24px;
  font-weight: 600;
  font-size: 15px;
  min-height: 48px;
  text-transform: none;
  letter-spacing: 0;
}
@media (max-width: 576px) {
  .invitation-response-container .response-actions {
    gap: 8px;
  }
  .invitation-response-container .response-actions .response-button {
    --padding-top: 12px;
    --padding-bottom: 12px;
    --padding-start: 16px;
    --padding-end: 16px;
    font-size: 14px;
    min-height: 44px;
  }
}
@media (max-width: 375px) {
  .invitation-response-container .response-actions {
    gap: 6px;
    flex-direction: column;
  }
  .invitation-response-container .response-actions .response-button {
    --padding-top: 10px;
    --padding-bottom: 10px;
    --padding-start: 12px;
    --padding-end: 12px;
    font-size: 13px;
    min-height: 40px;
    width: 100%;
  }
}
.invitation-response-container .response-actions .accept-button,
.invitation-response-container .response-actions .maybe-button,
.invitation-response-container .response-actions .decline-button {
  flex: 1;
  --background: transparent;
  --background-activated: #ed143d;
  --background-hover: #ed143d;
  --color-hover: #ffffff;
  --color: #ed143d;
  --border-width: 0;
  font-weight: 700;
  text-align: center;
}
.invitation-response-container .response-actions .accept-button.selected,
.invitation-response-container .response-actions .maybe-button.selected,
.invitation-response-container .response-actions .decline-button.selected {
  --background: #ed143d;
  --color: #ffffff;
  --border-color: #ed143d;
}

@media (min-width: 576px) {
  .invitation-response-container {
    position: static;
    margin: 100px 0 20px 0;
    padding: 20px;
    background: #fff;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/event/event.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;AACF;AAAE;EACE,SAAA;AAEJ;AAAE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAEJ;;AACA;EACE,aAAA;EACA,QAAA;EACA,OAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AAEF;AADE;EACE,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AAGJ;AAFI;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AAIN;;AAAA;EACE,aAAA;EACA,mBAAA;AAGF;AAFE;EACE,gBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAIJ;AAFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,OAAA;AAIJ;;AADA;EAEE,WAAA;EACA,kBAAA;EACA,yBAAA;AAGF;AADE;EACE,aAAA;EACA,sBAAA;EACA,wCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;AAGJ;AAFI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAIN;AAFM;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AAIR;AAHQ;EACE,aAAA;EACA,mBAAA;AAKV;AAJU;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAMZ;AAJU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAMZ;AALY;EAEE,iBAAA;AAMd;AAJY;EACE,cAAA;AAMd;AADM;EACE,WAAA;EACA,gBAAA;AAGR;AAAI;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AACN;AACM;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;AACR;AAAQ;EACE,cAAA;EACA,eAAA;AAEV;AACM;EAGE,mBAAA;EACA,gBAAA;EACA,qBAAA;AADR;;AAQA;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;AALF;;AAQA;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,YAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,cAAA;EACA,2BAAA;AALF;;AAUE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAPJ;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;AAPF;;AAUA;EACE,oBAAA;AAPF;;AASA;EACE,oBAAA;EACA,aAAA;AANF;;AAQA;EACE,aAAA;EACE,SAAA;EACA,mBAAA;EACA,8BAAA;AALJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AALF;AAOE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AAQE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AANJ;;AAUA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAPF;;AAUA;EACE,qBAAA;EACA,6BAAA;EACA,iBAAA;AAPF;AASE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,wCAAA;AAPJ;AASI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAPN;;AAWA;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AARF;AAUE;EANF;IAOI,sBAAA;IACA,kBAAA;EAPF;AACF;AASE;EAXF;IAYI,qBAAA;IACA,iBAAA;EANF;AACF;AAQE;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AANJ;AASE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAPJ;AASI;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAPN;AAUI;EAlBF;IAmBI,QAAA;EAPJ;EASI;IACE,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;EAPN;AACF;AAUI;EA/BF;IAgCI,QAAA;IACA,sBAAA;EAPJ;EASI;IACE,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EAPN;AACF;AAUI;;;EAGE,OAAA;EACA,yBAAA;EACA,+BAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AARN;AAUM;;;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;AANR;;AAYA;EACE;IACE,gBAAA;IACA,sBAAA;IACA,aAAA;IACA,gBAAA;EATF;AACF","sourcesContent":[".error-container {\n  background: #ed143d;\n  color: white;\n  padding: 8px;\n  font-size: 16px;\n  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  gap: 5px;\n  p {\n    margin: 0;\n  }\n  ion-icon {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n  }\n}\n.weekdays-container {\n  display: flex;\n  gap: 5px;\n  flex: 1;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  ion-badge {\n    background: none;\n    color: #333;\n    border: 1px solid #333;\n    padding: 5px 6px;\n    &.selected {\n      background: #ed143d;\n      color: white;\n      border: 1px solid #ed143d;\n    }\n  }\n}\n.recurrence-end {\n  display: flex;\n  align-items: center;\n  span {\n    font-weight: 600;\n    flex: 0.75;\n    color: #888;\n    margin: 0;\n    font-size: 15px;\n    padding: 0;\n  }\n  ion-chip {\n    display: flex;\n    justify-content: space-between;\n    border-radius: 12px;\n    font-weight: 700;\n    letter-spacing: 1.2px;\n    flex: 1;\n  }\n}\n.container {\n  // height:100%;\n  margin: 5px;\n  border-radius: 8px;\n  padding: 0 15px 50px 15px;\n\n  .time-container {\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    background: #efefef;\n    padding: 5px 10px;\n    border-radius: 8px;\n    margin-block: 10px 20px;\n    gap: 2px;\n    .meeting-time {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .start-end-container {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        div {\n          display: flex;\n          align-items: center;\n          span {\n            font-weight: 600;\n            flex: 0.5;\n            font-size: 15px;\n            color: #888;\n            margin: 0;\n            padding: 0;\n          }\n          ion-chip {\n            display: flex;\n            justify-content: center;\n            border-radius: 12px;\n            font-weight: 700;\n            white-space: nowrap;\n            &.date-chip {\n              // flex: 1;\n              margin-left: auto;\n            }\n            ion-icon {\n              color: #ed143d;\n            }\n          }\n        }\n      }\n      .all-day {\n        margin: 4px;\n        margin-left: 0px;\n      }\n    }\n    .duration {\n      // margin: 5px 0;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      position: relative;\n\n      span {\n        display: flex;\n        font-size: 15px;\n        align-items: center;\n        font-weight: 600;\n        color: #888;\n        gap: 5px;\n        ion-icon {\n          color: #ed143d;\n          font-size: 18px;\n        }\n      }\n      ion-chip {\n        // display: flex;\n        // justify-content: space-between;\n        border-radius: 12px;\n        font-weight: 700;\n        letter-spacing: 1.2px;\n        // flex: 1;\n      }\n    }\n  }\n}\n\nion-toggle {\n  font-weight: 600;\n  display: block;\n  margin: 0 auto;\n  --track-background-checked: #ed143d;\n  width: 100%;\n}\n\nion-datetime {\n  --ion-color-primary: #ed143d;\n  box-shadow: none;\n  padding-top: 8px;\n}\n\nion-datetime::part(calendar-day):focus {\n  box-shadow: none;\n}\n\nion-datetime::part(time-button) {\n  background: #fff9f9;\n  border: 2px solid #ed143d;\n  font-weight: 600;\n}\n\nion-datetime.disabled-time::part(time-button) {\n  pointer-events: none;\n  opacity: 0.3;\n}\n\nion-datetime::part(month-year-button) {\n  color: #ed143d;\n  padding-block: 0;\n  transform: translateY(-8px);\n}\n\nion-popover.datetime-popover::part(content) {\n  --width: 350px;\n  --max-width: 90%;\n  --height: auto;\n}\n\nion-select::part(label) {\n  color: #888;\n  font-size: 17px;\n}\n\nion-select::part(container) {\n  font-size: 15px;\n}\n\nion-select::part(icon) {\n  color: #ed143d;\n  transform: translateY(10px);\n}\n\nion-select {\n  // transform: translateY(-4px);\n  ion-icon {\n    color: #ed143d;\n    font-size: 20px;\n    margin-right: 10px;\n  }\n}\nion-popover.duration-popover {\n  --offset-y: -200px;\n}\n\n.subject-input {\n  font-weight: 600;\n  padding: 10px 0 !important;\n  margin: 10px;\n  font-size: 21px;\n}\n\nion-input::ng-deep .input-clear-icon {\n  justify-content: end;\n}\n.disabled-page {\n  pointer-events: none;\n  opacity: 0.55;\n}\n.resource-and-edit-icon-container {\n  display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.resource-email-row {\n  display: flex;\n  align-items: center;\n  padding: 4px 0 0 8px;\n  font-size: 14px;\n  color: #555;\n}\n\n.detail-row {\n  display: flex;\n  align-items: center;\n  padding: 10px 0 4px 0;\n  font-size: 16px;\n\n  .detail-label {\n    color: #888;\n    font-weight: 600;\n    margin-right: auto;\n  }\n\n  .detail-value {\n    color: #333;\n    font-weight: 500;\n    text-align: right;\n  }\n}\n\n.organizer-icon {\n  width: 22px;\n  height: 22px;\n  margin-right: 10px;\n}\n\n.resource-map-container {\n  margin: 10px 0 20px 0;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 15px;\n\n  .map-container {\n    width: 100%;\n    height: 250px;\n    border-radius: 8px;\n    overflow: hidden;\n    margin: 0 auto;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n    iframe {\n      border-radius: 8px;\n      width: 100%;\n      height: 100%;\n      border: none;\n    }\n  }\n}\n.invitation-response-container {\n  position: static;\n  margin: 100px 0 20px 0;\n  padding: 20px 16px;\n  background: #fff;\n  \n  @media (max-width: 576px) {\n    margin: 100px 0 15px 0;\n    padding: 15px 12px;\n  }\n  \n  @media (max-width: 375px) {\n    margin: 80px 0 12px 0;\n    padding: 12px 8px;\n  }\n\n  .response-loading {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n  }\n\n  .response-actions {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n\n    .response-button {\n      --border-radius: 8px;\n      --padding-top: 14px;\n      --padding-bottom: 14px;\n      --padding-start: 24px;\n      --padding-end: 24px;\n      font-weight: 600;\n      font-size: 15px;\n      min-height: 48px;\n      text-transform: none;\n      letter-spacing: 0;\n    }\n    \n    @media (max-width: 576px) {\n      gap: 8px;\n      \n      .response-button {\n        --padding-top: 12px;\n        --padding-bottom: 12px;\n        --padding-start: 16px;\n        --padding-end: 16px;\n        font-size: 14px;\n        min-height: 44px;\n      }\n    }\n    \n    @media (max-width: 375px) {\n      gap: 6px;\n      flex-direction: column;\n      \n      .response-button {\n        --padding-top: 10px;\n        --padding-bottom: 10px;\n        --padding-start: 12px;\n        --padding-end: 12px;\n        font-size: 13px;\n        min-height: 40px;\n        width: 100%;\n      }\n    }\n\n    .accept-button,\n    .maybe-button,\n    .decline-button {\n      flex: 1;\n      --background: transparent;\n      --background-activated: #ed143d;\n      --background-hover: #ed143d;\n      --color-hover: #ffffff;\n      --color: #ed143d;\n      --border-width: 0;\n      font-weight: 700;\n      text-align: center;\n      \n      &.selected {\n        --background: #ed143d;\n        --color: #ffffff;\n        --border-color: #ed143d;\n      }\n    }\n  }\n}\n\n@media (min-width: 576px) {\n  .invitation-response-container {\n    position: static;\n    margin: 100px 0 20px 0;\n    padding: 20px;\n    background: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
